export const getCountyLabel = (countryCode: string) => {
  if (countryCode === 'USA') {
    return 'State';
  }
  if (countryCode === 'CAN') {
    return 'Province';
  }
  return 'County';
};
